import * as React from 'react';

interface IProps {
  classes: string;
  buttonText: string;
  onClick: (event) => void;
}

export default class CreditCardFormToggleButton extends React.Component<IProps, null> {
  render() {
    return (
      <a
        className={this.props.classes}
        onClick={this.props.onClick}
      >
        {this.props.buttonText}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/onboarding/credit_card_form_toggle_button.tsx